import { Flex, Table } from '@zillow/constellation';
import React from 'react';
import { IOrderTaskData } from 'types/tasks';
import { EditRoleDisplay } from './EditRole';
import { EditCompletedByDisplay, EditCompletedByField } from './EditCompletedBy';
import { EditCompletedAtDateDisplay, EditCompletedAtDateField } from './EditCompletedAtDate';
import { EditTaskDescriptionDisplay } from './EditTaskDescription';
import { EditCompletedAtTimeDisplay, EditCompletedAtTimeField } from './EditCompletedAtTime';
import { CompletedTaskEditForm } from './CompletedTaskEditForm';
import { useHasPermissions } from 'components/accessControl/hooks/useHasPermissions';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';

export interface ICompletedTaskRowProps {
  tasks: IOrderTaskData[];
}

export const CompletedTaskRows: React.FC<ICompletedTaskRowProps> = ({ tasks }) => {
  const hasPermission = useHasPermissions([ePermissions.CompletedTasksEdit]);
  return (
    <>
      {tasks?.map((task) => (
        <Table.Row key={task.id}>
          <Table.Cell></Table.Cell>
          <Table.Cell>
            <EditTaskDescriptionDisplay task={task} />
          </Table.Cell>
          <Table.Cell>
            <EditRoleDisplay task={task} />
          </Table.Cell>
          <Table.Cell>
            <CompletedTaskEditForm
              task={task}
              display={EditCompletedByDisplay}
              form={hasPermission ? EditCompletedByField : undefined}
            />
          </Table.Cell>
          <Table.Cell>
            <Flex display={'flex'} alignItems={'center'} gap={1}>
              <CompletedTaskEditForm
                task={task}
                display={EditCompletedAtDateDisplay}
                form={hasPermission ? EditCompletedAtDateField : undefined}
              />{' '}
              at{' '}
              <CompletedTaskEditForm
                task={task}
                display={EditCompletedAtTimeDisplay}
                form={hasPermission ? EditCompletedAtTimeField : undefined}
              />
            </Flex>
          </Table.Cell>
        </Table.Row>
      ))}
    </>
  );
};
